import type { PropertyType } from '@/backend/types'
import CollectionEntitySidebar from '@/modules/Project/Fields/registry/collection/CollectionEntitySidebar.vue'
import CollectionField from '@/modules/Project/Fields/registry/collection/CollectionField.vue'
import FileEntitySidebar from '@/modules/Project/Fields/registry/file/FileEntitySidebar.vue'
import FileField from '@/modules/Project/Fields/registry/file/FileField.vue'
import FileCollectionEntitySidebar from '@/modules/Project/Fields/registry/filecollection/FileCollectionEntitySidebar.vue'
import FileCollectionField from '@/modules/Project/Fields/registry/filecollection/FileCollectionField.vue'
import JsonEntitySidebar from '@/modules/Project/Fields/registry/json/JsonEntitySidebar.vue'
import JsonField from '@/modules/Project/Fields/registry/json/JsonField.vue'
import MultiSelectEntitySidebar from '@/modules/Project/Fields/registry/multiselect/MultiSelectEntitySidebar.vue'
import MultiSelectField from '@/modules/Project/Fields/registry/multiselect/MultiSelectField.vue'
import NumberEntitySidebar from '@/modules/Project/Fields/registry/number/NumberEntitySidebar.vue'
import NumberField from '@/modules/Project/Fields/registry/number/NumberField.vue'
import ReferenceEntitySidebar from '@/modules/Project/Fields/registry/reference/ReferenceEntitySidebar.vue'
import ReferenceField from '@/modules/Project/Fields/registry/reference/ReferenceField.vue'
import SingleSelectEntitySidebar from '@/modules/Project/Fields/registry/singleselect/SingleSelectEntitySidebar.vue'
import TextEntitySidebar from '@/modules/Project/Fields/registry/text/TextEntitySidebar.vue'
import TextField from '@/modules/Project/Fields/registry/text/TextField.vue'
import URLEntitySidebar from '@/modules/Project/Fields/registry/url/URLEntitySidebar.vue'
import URLField from '@/modules/Project/Fields/registry/url/URLField.vue'
import UserSelectEntitySidebar from '@/modules/Project/Fields/registry/userselect/UserSelectEntitySidebar.vue'
import SidebarSelectField from '@/modules/Project/Fields/SidebarSelectField.vue'
import type { Field } from './types'

/**
 * Intended to be a global source of truth for which components are used to render fields in different contexts.
 */
export const fieldRegistry = {
  single_select: {
    field: SidebarSelectField<'single_select'>,
    entitySidebar: SingleSelectEntitySidebar,
  },
  multi_select: { field: MultiSelectField, entitySidebar: MultiSelectEntitySidebar },
  collection: { field: CollectionField, entitySidebar: CollectionEntitySidebar },
  reference: { field: ReferenceField, entitySidebar: ReferenceEntitySidebar },
  url: { field: URLField, entitySidebar: URLEntitySidebar },
  json: { field: JsonField, entitySidebar: JsonEntitySidebar },
  text: { field: TextField, entitySidebar: TextEntitySidebar },
  file: { field: FileField<'file'>, entitySidebar: FileEntitySidebar<'file'> },
  user_select: { field: SidebarSelectField<'user_select'>, entitySidebar: UserSelectEntitySidebar },
  number: { field: NumberField, entitySidebar: NumberEntitySidebar },
  file_collection: { field: FileCollectionField, entitySidebar: FileCollectionEntitySidebar },
  data: { field: FileField<'data'>, entitySidebar: FileEntitySidebar<'data'> },
} as const

export const getRawValue = <T extends PropertyType>(field: Field<T>) =>
  field.manualValue || field.toolValue

export const getEntityFieldComponent = <T extends PropertyType>(
  field: Field<T>,
): (typeof fieldRegistry)[T]['field'] => fieldRegistry[field.type].field

export const getEntityFieldSidebar = <T extends PropertyType>(
  field: Field<T>,
): (typeof fieldRegistry)[T]['entitySidebar'] => fieldRegistry[field.type].entitySidebar
